import React__default from 'react';
import styled from 'styled-components';
import { useLinkComponent } from '../../provider/Provider.js';
import { tokens } from '../../tokens.js';
import { Text } from '../text/Text.js';

const StyledText = styled(Text)`
  text-decoration: underline;
  color: inherit;

  &:visited,
  &:active {
    color: inherit;
  }

  &:focus,
  &:hover {
    color: ${tokens.components.link.hover.color};
    outline: none;
  }
`;
/**
 * System-aware Link. Will leverage the provided Happy Design link component to render client-side aware links (such as
 * React Router `Link` components).
 *
 * For external links, defaults back to a standard Anchor tag that will open in a new tab.
 *
 * @example
 * // Internal link within current app
 * <Link to='./somewhere' />
 * // External link that will open in new tab
 * <Link to='https://somewhere.com' />
 * <Link to='somewhere.com' externalLink={true} />
 */ const Link = ({ testId ="X" , externalLink =false , children , ...props })=>{
    let element = useLinkComponent();
    if (externalLink || typeof props?.to === "string" && props?.to.startsWith("http")) {
        props.href = props.to;
        props.target = "_blank";
        props.rel = "noreferrer";
        element = "a";
    }
    // This is a fix for a bug in the way the Link was initially setup to passthrough test ids - it didn't append `Link-`
    // like other components, rather dropped it when being used as a projected component
    let proxiedTestId = "Link-" + testId;
    if (testId?.startsWith("Button-")) {
        proxiedTestId = testId;
    }
    return React__default.createElement(StyledText, {
        ...props,
        "data-hpy-web-link": true,
        "data-test-id": proxiedTestId,
        as: element
    }, children);
};
Link.dataId = "data-hpy-web-link";
Link.displayName = "Link";

export { Link };
